import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid2';
import { OverviewSkeleton } from './OverviewSkeleton';
import { DetailsGrid } from '../DetailsGrid';
import { useAssemblyData } from '../hooks/useAssemblyData';
import { useFieldFormatting } from '../hooks/useFieldFormatting';
import { useGetDetailsData } from '../hooks/useGetDetailsData';

type DetailsSectionProps = {
  displayGeneralData?: boolean;
  displayDefectsData?: boolean;
};

export const DetailsSection = ({
  displayGeneralData = true,
  displayDefectsData = true,
}: DetailsSectionProps) => {
  const { assemblyDetails, assemblyArea, assemblyDataLoading, defectLegends } = useAssemblyData();
  const { getFieldName, displayableFields, getFormattedValueDetails } = useFieldFormatting(
    assemblyDetails,
    assemblyArea
  );
  const { assemblyGeneralData, assemblyDefectsData } = useGetDetailsData(
    assemblyDetails,
    defectLegends
  );

  if (assemblyDataLoading) {
    return (
      <Stack padding="2.4rem" gap="2.4rem" sx={{ overflowY: 'auto' }}>
        <OverviewSkeleton />
      </Stack>
    );
  }

  return (
    <Grid container spacing="2.6rem" sx={{ width: '100%', p: '4rem', pt: '1.4rem' }}>
      {assemblyDetails && assemblyGeneralData && displayGeneralData && (
        <DetailsGrid
          title="General"
          data={assemblyGeneralData}
          getFieldName={getFieldName}
          getFormattedValue={getFormattedValueDetails}
          displayableFields={displayableFields}
        />
      )}

      {assemblyDetails &&
        assemblyDefectsData &&
        displayDefectsData &&
        assemblyDefectsData.map((defectsData, index) => (
          <DetailsGrid
            key={index}
            title={defectsData.title}
            data={defectsData.data}
            getFieldName={getFieldName}
            getFormattedValue={getFormattedValueDetails}
            displayableFields={displayableFields}
          />
        ))}
    </Grid>
  );
};
